/* __next_internal_client_entry_do_not_use__ FooterBanner auto */import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Translate } from "@/components/topic/Translate";
import { getDetailUrl, getUpdateTime, notLoginHandle } from "@/helpers/blog";
export const FooterBanner = param => {
  let {
    latest
  } = param;
  return /*#__PURE__*/_jsxs("div", {
    className: "footer-banner",
    children: [/*#__PURE__*/_jsx("div", {
      className: "latest-article-container",
      children: /*#__PURE__*/_jsxs("div", {
        className: "latest-article",
        children: [/*#__PURE__*/_jsx("p", {
          className: "latest-article-title",
          children: /*#__PURE__*/_jsx(Translate, {
            translateKey: "Seo_Footer_Latest_From"
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "latest-article-list",
          children: latest.map((item, index) => {
            return /*#__PURE__*/_jsxs("a", {
              className: "latest-article-item",
              href: getDetailUrl(item.urlName, item.language),
              target: "_blank",
              children: [/*#__PURE__*/_jsx("p", {
                className: "latest-article-item-category",
                children: item.category
              }), /*#__PURE__*/_jsx("p", {
                className: "latest-article-item-title",
                children: item.title
              }), /*#__PURE__*/_jsx("div", {
                className: "latest-article-item-date article-time",
                children: getUpdateTime(item.updateDate)
              })]
            }, index);
          })
        })]
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "user-guide",
      children: [/*#__PURE__*/_jsx("p", {
        className: "user-guide-title",
        children: /*#__PURE__*/_jsx(Translate, {
          translateKey: "Seo_Footer_Title"
        })
      }), /*#__PURE__*/_jsx("p", {
        className: "user-guide-desc",
        children: /*#__PURE__*/_jsx(Translate, {
          translateKey: "Seo_Footer_Desc"
        })
      }), /*#__PURE__*/_jsx("p", {
        onClick: notLoginHandle,
        className: "user-guide-button",
        children: /*#__PURE__*/_jsx(Translate, {
          translateKey: "Seo_Footer_Button"
        })
      }), /*#__PURE__*/_jsx("p", {
        className: "user-guide-button-desc",
        children: /*#__PURE__*/_jsx(Translate, {
          translateKey: "Seo_Footer_Button_Desc"
        })
      })]
    })]
  });
};